import React from 'react';
import { BrowserRouter, Routes, Route, Navigate, Outlet } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { AuthProvider } from './context/AuthContext';
import { LanguageProvider } from './context/LanguageContext';
import { ThemeProvider } from './context/ThemeContext';
import { ProtectedRoute } from './components/ProtectedRoute';
import { DashboardLayout } from './components/DashboardLayout';
import { Toaster } from './components/ui/sonner';
import { LandingPage } from './pages/LandingPage';
import { Login } from './pages/Login';
import { Register } from './pages/Register';
import { ForgotPassword } from './pages/ForgotPassword';
import { ResetPassword } from './pages/ResetPassword';
import { VerifyEmail } from './pages/VerifyEmail';
import { GoogleCallback } from './pages/GoogleCallback';
import { Dashboard } from './pages/Dashboard';
import { Feedback } from './pages/Feedback';
import { Roadmap } from './pages/Roadmap';
import { Changelog } from './pages/Changelog';
import { Widget } from './pages/Widget';
import { Team } from './pages/Team';
import { Settings } from './pages/Settings';
import { ProjectSettings } from './pages/ProjectSettings';
import { PublicFeedback } from './pages/PublicFeedback';
import { PublicRoadmap } from './pages/PublicRoadmap';
import { PublicChangelog } from './pages/PublicChangelog';
import { BlogDetail } from './pages/BlogDetail';
import { LegalDocument } from './pages/LegalDocument';
import { PricingRedirect } from './pages/PricingRedirect';
import { NotFound } from './pages/NotFound';
import './App.css';

// Dashboard layout wrapper component
const DashboardLayoutWrapper = () => (
  <DashboardLayout>
    <Outlet />
  </DashboardLayout>
);

function App() {
  return (
    <HelmetProvider>
      <LanguageProvider>
        <AuthProvider>
          <BrowserRouter>
            <ThemeProvider>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/pricing" element={<PricingRedirect />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/verify-email" element={<VerifyEmail />} />
          <Route path="/auth/google/callback" element={<GoogleCallback />} />

          {/* Dashboard Routes - Wrapped in DashboardLayout */}
          <Route
            path="/dashboard/*"
            element={
              <ProtectedRoute>
                <DashboardLayoutWrapper />
              </ProtectedRoute>
            }
          >
            <Route path="" element={<Dashboard />} />
            <Route path="feedback" element={<Feedback />} />
            <Route path="roadmap" element={<Roadmap />} />
            <Route path="changelog" element={<Changelog />} />
            <Route path="widget" element={<Widget />} />
            <Route path="team" element={<Team />} />
            <Route path="settings" element={<Settings />} />
            <Route path="project-settings" element={<ProjectSettings />} />
          </Route>

          {/* Blog Pages */}
          <Route path="/blog/:slug" element={<BlogDetail />} />

          {/* Legal Documents */}
          <Route path="/legal/:type" element={<LegalDocument />} />

          {/* Public Pages */}
          <Route path="/feedback/:tenantSlug" element={<PublicFeedback />} />
          <Route path="/roadmap/:tenantSlug" element={<PublicRoadmap />} />
          <Route path="/changelog/:tenantSlug" element={<PublicChangelog />} />

          {/* Catch-all: unknown paths render a 404 body. nginx serves them with a
              real 404 status (see nginx.conf), so crawlers stop treating every
              made-up URL as a valid page. */}
          <Route path="*" element={<NotFound />} />
        </Routes>
        <Toaster position="top-right" />
            </ThemeProvider>
          </BrowserRouter>
        </AuthProvider>
      </LanguageProvider>
    </HelmetProvider>
  );
}

export default App;